import {Directive, ElementRef, HostListener, NgModule, Renderer2} from '@angular/core';

@Directive({
	selector: '[libImageLoad]'
})
export class ImageLoadDirective {
	constructor(private el: ElementRef, private renderer: Renderer2) {
		this.addSpinner();
	}

	addSpinner() {
		if (!this.el.nativeElement.parentElement.childNodes) return;
		const spinner: HTMLElement = this.renderer.createElement('span');
		this.renderer.addClass(spinner, 'spinner-border');
		this.renderer.appendChild(this.el.nativeElement.parentElement, spinner);
	}

	@HostListener('load')
	onLoad() {
		if (!this.el.nativeElement.parentElement.childNodes) return;
		this.el.nativeElement.parentElement.childNodes
			.forEach((el: HTMLElement) => {
				if (!el.className.includes('spinner')) return;
				this.renderer.addClass(el, 'd-none');
			});
	}

	@HostListener('error')
	onError() {
		if (!this.el.nativeElement.parentElement.childNodes) return;
		this.el.nativeElement.parentElement.childNodes
			.forEach((el: HTMLElement) => {
				if (!el.className.includes('spinner')) return;
				this.renderer.addClass(el, 'd-none');
			});
	}
}

@NgModule({
	declarations: [ImageLoadDirective],
	exports: [ImageLoadDirective]
})
export class ImageLoadDirectiveModule {}
